import script from "./TextHover.vue?vue&type=script&setup=true&lang=js"
export * from "./TextHover.vue?vue&type=script&setup=true&lang=js"

import "./TextHover.vue?vue&type=style&index=0&id=0cde282b&lang=less&scoped=true"
import "./TextHover.vue?vue&type=style&index=1&id=0cde282b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cde282b"]])

export default __exports__